import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useParams } from "react-router-dom";
import {
  //   DownloadPDFOrderIssueDetails,
  getOrderById,
} from "./services/order.services";
import { clearOrderDetail } from "./orderSlice";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  checkAcessRights,
  formatToIndianCurrency,
  formatWeight,
} from "../../_helper/helper";
import { PRINT_ACCESS } from "../../_contstants/common";
import { IoMdPrint } from "react-icons/io";
import moment from "moment";
import { LoadingPanel } from "../../components/layout/Loading";
// import { MdOutlineFileDownload } from "react-icons/md";
// import { API_URL } from "../../app/config";
// import { ErrorToast } from "../../components/toast/Toasts";
import { Checkbox } from "@progress/kendo-react-inputs";

const OrderStatusPDF = () => {
  const dispatch = useAppDispatch();
  const param = useParams();
  const order_guid = param?.order_guid || "";
  const OrderDetail = useAppSelector((state) => state.order.OrderDetail);
  const loading = useAppSelector((state) => state.order.loading);
  const isPrintAccess = checkAcessRights("/order", PRINT_ACCESS);
  const gridRef = useRef<any>(null);
  const [withImage, setWithImage] = useState(false);
  const [sendToVepari, setSendToVepari] = useState(false);

  const handleWithImage = () => {
    setWithImage((pre) => !pre);
  };

  const handleSendToVepari = () => {
    setSendToVepari((pre) => !pre);
    setWithImage(sendToVepari ? false : true);
  };

  useEffect(() => {
    return () => {
      dispatch(clearOrderDetail());
    };
  }, []);

  useEffect(() => {
    if (order_guid) {
      dispatch(getOrderById(order_guid));
    }
  }, [order_guid]);

  useEffect(() => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .no-print {
          display: none !important;
        }
        .issue-order-item-print-break {
          page-break-inside: avoid;
        }
        .container {
          width: 100% !important;
          max-width: 100% !important;
          padding: 0 !important;
          margin: 0 !important;
        }
        body {
          zoom: 70% !important;
        }
        .table-bordered, .table-bordered td, .table-bordered th {
          border: 1px solid #c2c2c2ff !important;
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handlePrint = () => {
    window.print();
  };

/*
  const handleDownloadPdf = async (order_guid: string, issue_no: any) => {
    try {
      const response = await fetch(
        `${API_URL}/Order/FIndByIDOrderDownloadPDf`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            order_guid,
            isimageview: withImage,
            sendToVepari: sendToVepari,
          }),
        },
      );

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Order-Issue-${issue_no || moment().date()}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download PDF! - Please try again later");
    }
  };
*/

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}

      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <div
            className="printbuttons no-print"
            style={{
              textAlign: "center",
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {isPrintAccess && (
              <>
                <div
                  style={{
                    marginRight: "10px",
                    padding: "3px 10px",
                    border: "none",
                  }}
                >
                  <Checkbox
                    label="With Image "
                    size="large"
                    labelPlacement="before"
                    onChange={handleWithImage}
                    checked={withImage}
                  />
                </div>
                <div
                  style={{
                    marginRight: "10px",
                    padding: "3px 10px",
                    border: "none",
                  }}
                >
                  <Checkbox
                    label="Send to Vepari "
                    size="large"
                    labelPlacement="before"
                    onChange={handleSendToVepari}
                    checked={sendToVepari}
                  />
                </div>
                <Button
                  type="button"
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={handlePrint}
                >
                  <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                </Button>
              </>
            )}
            {/* {isPrintAccess && (
              <Button
                type="button"
                style={{
                  marginRight: "10px",
                  padding: "5px 10px",
                  border: "none",
                }}
                fillMode={"solid"}
                themeColor={"tertiary"}
                onClick={() =>
                  handleDownloadPdf(order_guid, OrderDetail.order_no)
                }
              >
                <MdOutlineFileDownload style={{ fontSize: "20px" }} /> Download
              </Button>
            )} */}
          </div>
        </GridLayoutItem>
        <GridLayoutItem>
          <Typography.h5
            style={{
              marginBottom: 0,
              textAlign: "center",
            }}
          >
            ORDER DETAIL
          </Typography.h5>
          <Typography.h6
            style={{
              marginBottom: 15,
              textAlign: "center",
            }}
          >
            ORDER NO : {OrderDetail?.order_no} | ORDER DATE :{" "}
            {moment(OrderDetail?.order_date).format("DD/MM/YYYY")} | DELIVERY
            DATE : {moment(OrderDetail?.delivery_date).format("DD/MM/YYYY")}
          </Typography.h6>
        </GridLayoutItem>
      </GridLayout>

      <div className="container">
        {/* Summary Information */}
        <div className="card summary-card mb-3">
          <div className="card-header bg-light">
            <h5 className="mb-0 fw-bold">Order Summary</h5>
          </div>
          <div className=" p-0">
            <table className="table table-bordered mb-0">
              <tbody>
                <tr>
                  <td style={{ width: "25%" }}>
                    <strong>Party Name</strong>
                    <br />
                    <span>{OrderDetail?.party_name}</span>
                  </td>
                  <td style={{ width: "25%" }}>
                    <strong>Item Name</strong>
                    <br />
                    <span>{OrderDetail?.item_name}</span>
                  </td>
                  <td style={{ width: "25%" }}>
                    <strong>Priority</strong>
                    <br />
                    <span>{OrderDetail?.priority}</span>
                  </td>
                  <td style={{ width: "25%" }}>
                    <strong>Estimated Weight (g,)</strong>
                    <br />
                    <span>{OrderDetail?.estimate_weight}</span>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "25%" }}>
                    <strong>Estimate Amount</strong>
                    <br />
                    <span className="text-success">
                      {formatToIndianCurrency(
                        OrderDetail?.estimate_amount || 0,
                      )}
                    </span>
                  </td>
                  <td style={{ width: "25%" }}>
                    <strong>Size</strong>
                    <br />
                    <span>{OrderDetail?.size}</span>
                  </td>
                  <td style={{ width: "25%" }}>
                    <strong>Purity</strong>
                    <br />
                    <span>
                      {(OrderDetail?.Carat || "") +
                        " " +
                        (OrderDetail?.PurityValue || "")}
                    </span>
                  </td>
                  <td style={{ width: "25%" }}>
                    <strong>Color</strong>
                    <br />
                    <span>{OrderDetail?.color}</span>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4} style={{ width: "25%" }}>
                    <strong>Description</strong>
                    <br />
                    <span>{OrderDetail?.remark}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* {sendToVepari ? (
          <div className="mt-4">
            <h5 className="mb-3 fw-bold">Image</h5>
            <div className="d-flex flex-wrap gap-3">
              {OrderDetail?.processdetails
                ?.filter((item: any) => item?.isreadyimage)
                ?.slice(0, 1)
                ?.map((item: any, index: number) => (
                  <div
                    key={index}
                    className="card shadow-sm border-0 text-center p-2"
                    style={{ width: "240px" }}
                  >
                    <img
                      src={item.Image}
                      alt={item.process_name}
                      className="img-fluid rounded"
                      style={{
                        objectFit: "cover",
                        height: "240px",
                        width: "100%",
                      }}
                    />
                  </div>
                ))}
            </div>
          </div>
        ) : ( */}
        <>
          {OrderDetail?.processdetails?.map((item, index) => {
            if (
              (item?.process_name !== "Ready" && sendToVepari) ||
              (item?.process_name === "Ready" && !sendToVepari)
            )
              return null;
            return (
              <div
                key={item?.process_id || index}
                className={`card items-card issue-order-item-print-break ${
                  index ? "mt-4" : ""
                }`}
              >
                <div className="card-body p-0">
                  <div className="p-1">
                    <div className="card items-card">
                      {item?.process_name !== "Ready" && (
                        <div className="card-body p-0">
                          <table className="table table-bordered mb-0">
                            <tbody>
                              <tr>
                                <td
                                  style={{ width: "10%", padding: "2px 5px" }}
                                >
                                  <p className="m-0">
                                    <strong>Process Name</strong>
                                  </p>
                                  <p className="m-0"> {item?.process_name}</p>
                                </td>
                                <td
                                  style={{ width: "10%", padding: "2px 5px" }}
                                >
                                  <p className="m-0">
                                    <strong>Karigar Name</strong>
                                  </p>
                                  <p className="m-0"> {item?.karigar_name}</p>
                                </td>
                                <td
                                  style={{ width: "10%", padding: "2px 5px" }}
                                >
                                  <p className="m-0">
                                    <strong>Process Weight (gm)</strong>
                                  </p>
                                  <p className="m-0">
                                    {formatWeight(item?.estimated_weight)}
                                  </p>
                                </td>
                                <td
                                  style={{ width: "10%", padding: "2px 5px" }}
                                >
                                  <p className="m-0">
                                    <strong>Approx work Start Date</strong>
                                  </p>
                                  <p className="m-0">
                                    {" "}
                                    {moment(item?.given_date).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </p>
                                </td>
                                <td
                                  style={{ width: "10%", padding: "2px 5px" }}
                                >
                                  <p className="m-0">
                                    <strong>Received Date</strong>
                                  </p>
                                  <p className="m-0">
                                    {" "}
                                    {moment(item?.receive_date).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </p>
                                </td>
                                <td
                                  style={{ width: "10%", padding: "2px 5px" }}
                                >
                                  <p className="m-0">
                                    <strong>Duration days</strong>
                                  </p>
                                  <p className="m-0">{item?.duration_days}</p>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  colSpan={6}
                                  style={{ width: "15%", padding: "2px 5px" }}
                                >
                                  <p className="m-0">
                                    <strong>Remarks</strong>
                                  </p>
                                  <p className="m-0"> {item?.description}</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {item?.sizedetails &&
                            item?.sizedetails.length > 0 && (
                              <div className="mt-2">
                                <h6>Size Details</h6>
                                <table className="table table-bordered mb-0">
                                  <thead>
                                    <tr>
                                      <th>Title</th>
                                      <th>Value</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {item?.sizedetails?.map(
                                      (sizes: any, idx: number) => (
                                        <tr key={sizes?.title || idx}>
                                          <td>{sizes?.title}</td>
                                          <td>{sizes?.value}</td>
                                        </tr>
                                      ),
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                        </div>
                      )}

                      <div
                        className={`card p-2 shadow-sm border-0 mb-4 ${
                          !withImage && `no-print`
                        }`}
                      >
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5
                            className="mb-0"
                            style={{
                              color: "#2c3e50",
                              fontWeight: "600",
                              fontSize: "1.1rem",
                            }}
                          >
                            {sendToVepari ? "Ready Image" : "Process Image"}
                          </h5>
                        </div>
                        <div className="d-flex flex-wrap gap-3">
                          {item?.ItemImages &&
                            item?.ItemImages?.length > 0 &&
                            item?.ItemImages?.map((img: any, idx: number) => (
                              <div
                                key={img?.image_name || idx}
                                className="position-relative rounded-3 overflow-hidden"
                                style={{
                                  width: "150px",
                                  transition: "all 0.3s ease",
                                }}
                              >
                                {img?.image_name && (
                                  <img
                                    className="img-fluid object-fit-cover"
                                    style={{ cursor: "pointer" }}
                                    src={img?.image_name}
                                    alt="Process Image"
                                    onClick={() => window.open(img?.image_name)}
                                  />
                                )}
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="table-responsive"> */}
                  {/* <table className="table table-bordered mb-0 issue-order-items-table">
                <tbody>
                  <tr>
                    <td>
                      <div className="card items-card">
                        <div className="card-header bg-light p-1">
                          <h6 className="mb-0">Item Details</h6>
                        </div>
                        <div className="card-body p-0">
                          <table className="table table-bordered mb-0">
                            <tbody>
                              <tr>
                                <td style={{ width: "25%" }}>
                                  <strong>Product</strong>
                                  <br />
                                  <span> Gold Chain 22 CT</span>
                                </td>
                                <td style={{ width: "25%" }}>
                                  <strong>Order No</strong>
                                  <br />
                                  <span>2</span>
                                </td>
                                <td style={{ width: "25%" }}>
                                  <strong>Size</strong>
                                  <br />
                                  <span>18</span>
                                </td>
                                <td style={{ width: "25%" }}>
                                  <strong>Weight</strong>
                                  <br />
                                  <span>26 gm</span>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Color</strong>
                                  <br />
                                  <span>Gold</span>
                                </td>
                                <td>
                                  <strong>Category</strong>
                                  <br />
                                  <span>Gold Chain</span>
                                </td>
                                <td>
                                  <strong>Purity</strong>
                                  <br />
                                  <span>22 CT</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="card items-card">
                        <div className="card-header bg-light p-1">
                          <h6 className="mb-0">Approval Items</h6>
                        </div>
                        <div className="card-body p-0">
                          <div className="approval-table">
                            <table className="table table-bordered mb-0 approval-items-table">
                              <thead>
                                <tr>
                                  <th>Type</th>
                                  <th>Item</th>
                                  <th>Weight</th>
                                  <th>Qty</th>
                                  <th>Remarks</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>SAMPLE</td>
                                  <td>Sample Chain</td>
                                  <td>60 gm</td>
                                  <td>2</td>
                                  <td>
                                    2 sample given asdfasd asdfasa asdfasd
                                    asdfasd
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table> */}
                  {/* <table className="table table-bordered mb-0 issue-order-items-table">
                <thead className="table-success">
                  <tr>
                    <th>Item Details</th>
                    <th>Specifications</th>
                    <th>Approval Items</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <h6
                        style={{
                          textTransform: "uppercase",
                          fontWeight: "bold",
                        }}
                      >
                        Gold Chain 22 CT
                      </h6>
                      <h6 className="text-muted">Order No : 2</h6>
                    </td>
                    <td>
                      <table className="table table-bordered specifications-table">
                        <tbody>
                          <tr>
                            <td>
                              <strong>Size</strong>
                            </td>
                            <td>18</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Weight</strong>
                            </td>
                            <td>26 gm</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Color</strong>
                            </td>
                            <td>Gold</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Category</strong>
                            </td>
                            <td>Gold Chain</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Purity</strong>
                            </td>
                            <td>22 CT</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      <div className="approval-table">
                        <table className="table table-bordered mb-0 approval-items-table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>Item</th>
                              <th>Weight</th>
                              <th>Qty</th>
                              <th>Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>SAMPLE</td>
                              <td>Sample Chain</td>
                              <td>60 gm</td>
                              <td>2</td>
                              <td>2 sample given</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table> */}
                  {/* </div> */}
                </div>
                {/* <div
                className={`card p-2 shadow-sm border-0 mb-4 ${
                  !withImage && `no-print`
                }`}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5
                    className="mb-0"
                    style={{
                      color: "#2c3e50",
                      fontWeight: "600",
                      fontSize: "1.1rem",
                    }}
                  >
                    Process Image
                  </h5>
                </div>
                <div className="d-flex flex-wrap gap-3">
                  <div
                    className="position-relative rounded-3 overflow-hidden"
                    style={{
                      width: "150px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {item?.ProcessImage && (
                      <img
                        className="img-fluid object-fit-cover"
                        src={item?.ProcessImage}
                        alt="Process Image"
                      />
                    )}
                  </div>
                </div>
              </div> */}
              </div>
            );
          })}
        </>
        {/* )} */}
      </div>
    </>
  );
};

export default OrderStatusPDF;
